import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function AuthorStorySection() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl font-bold text-terracotta text-center mb-12" data-id="element-11">
          Una Nota Personal
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative bg-sage/10 p-8 md:p-12 rounded-lg" data-id="element-12">
          <QuoteIcon className="absolute top-4 left-4 w-12 h-12 text-gold/30" data-id="element-13" />

          <div className="space-y-4 text-lg text-brown leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              Recuerdo perfectamente esa mañana. Me puse mis jeans favoritos,
              esos que siempre me quedaban perfectos, y no cerraron. No era solo
              el botón; era esa sensación de hinchazón y una fatiga que me
              pesaba en los huesos, aunque "supuestamente" había dormido 8
              horas.
            </p>
            <p data-id="element-16">
              Fui al médico y me dijo: "Es la edad, es normal, come menos y
              camina más". Hice caso. Comí ensaladas tristes, eliminé el arroz,
              caminé kilómetros... y me sentí peor. Estaba más cansada, más
              flácida y con más hambre.
            </p>
            <p className="font-semibold" data-id="element-17">
              Ese fue el momento en que decidí que "lo normal" no era suficiente
              para mí.
            </p>
            <p data-id="element-18">
              Empecé a investigar la ciencia de la sarcopenia (pérdida de
              músculo) y la resistencia a la insulina en la menopausia. Descubrí
              que a los 50+, las reglas del juego cambian. No necesitamos menos
              comida, necesitamos{' '}
              <span className="font-bold text-terracotta" data-id="element-19">
                mejor combustible
              </span>
              . No necesitamos más cardio, necesitamos{' '}
              <span className="font-bold text-terracotta" data-id="element-20">más fuerza</span>.
            </p>
            <p className="text-xl font-semibold text-terracotta italic" data-id="element-21">
              Este libro existe porque no quiero que pases ni un día más
              sintiéndote una extraña en tu propio cuerpo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}